import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';
import { IrbAgGridExportService } from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';

@Component({ standalone: false,
  selector: 'irb-ag-grid-export',
  templateUrl: './irb-ag-grid-export.component.html',
  styleUrls: ['./irb-ag-grid-export.component.scss']
})
export class IrbAgGridExportComponent implements OnInit {
  @Input() exportType: string = "excel";
  @Input() isGridRequired: boolean;
  @Input() exportOptions: any;
  @Input() rowData:any;
  @Output() callbackMethod = new EventEmitter<boolean>();
  params: any;

  constructor(private ges: IrbAgGridExportService) {     
  }

  ngOnInit() {
  }

  onGridReady(params: any) {
    this.params = params;
    this.export();
    this.callbackMethod.emit();
  }

  export() {
    if(this.exportType === "excel") {
      this.params.api.exportDataAsExcel(this.exportOptions.gridOptions.excelSheetParams);
    } else {
      const res = this.params.api.getDataAsCsv(this.exportOptions.gridOptions.excelSheetParams);
      this.ges.download(res);
    }

    this.isGridRequired =  false;
  }
}
